/**
 * Generated runtime TestId mirror for frontend/src/pages/Delegations.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const DelegationsTestIds = {
  colActions: "col-actions",
  colDelegator: "col-delegator",
  colDeputy: "col-deputy",
  colEndAt: "col-end-at",
  colReason: "col-reason",
  colStartAt: "col-start-at",
  colStatus: "col-status",
  colWorkflowStep: "col-workflow-step",
  delegationsList: "delegations-list",
  adminRevoke: (d_id: string) => `admin-revoke-${d_id}`,
  adminRevokePrefix: () => "admin-revoke-" as TestIdPrefix,
  delegationRow: (d_id: string) => `delegation-row-${d_id}`,
  delegationRowPrefix: () => "delegation-row-" as TestIdPrefix
} as const;
